import axios from "axios";

const BASE = `${process.env.REACT_APP_API}/template-variant`;

export async function listarVariantes(templateId, options = {}) {
  const { eventId, ...axiosOptions } = options;
  const params = eventId ? { ...(axiosOptions.params || {}), eventId } : axiosOptions.params;
  const res = await axios.get(`${BASE}/${templateId}`, { ...axiosOptions, params });
  return res.data;
}

export async function criarVariante(templateId, nome, config) {
  const res = await axios.post(BASE, { templateId, nome: nome || null, config });
  return res.data;
}

export async function atualizarVariante(id, nome, config) {
  const res = await axios.put(`${BASE}/${id}`, { nome, config });
  return res.data;
}

export async function deletarVariante(id) {
  await axios.delete(`${BASE}/${id}`);
}
